/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { IMenuItemModel, IMenuModel } from '../../../../models/Menu';
import FooterLink from '../footerLink';
import { Container, FooterMenuContainer } from './footerMenuStyled';

export interface IFooterMenuProps {
  item: IMenuItemModel;
  isBottomItem?: boolean;
}

const FooterMenu: FunctionalComponent<IFooterMenuProps> = ({ item, isBottomItem }) => {
  const { menuItemList } = item as IMenuModel;
  return (
    <Container>
      <FooterMenuContainer>
        {menuItemList.map((footerItem) => (
          <FooterLink key={footerItem.id} isBottomItem={isBottomItem} item={footerItem} />
        ))}
      </FooterMenuContainer>
    </Container>
  );
};

export default FooterMenu;
